// import request from "../utils/request.js"
import request from './service.js'
const baseUrl = 'https://serve.cmpreading.com';

export const classifyAgg = (params) => { 
    return request({
        url: `${baseUrl}/front/permit/classify/aggs`,
        method: 'GET',
        params,
    })
}
export const classifyList = (params) => { 
    return request({
        url: `${baseUrl}/front/permit/classify/list`,
        method: 'GET',
        params
    })
}
